module.exports = __webpack_public_path__ + "img/kiss-mark.27983f92.png";